import React from 'react';
import styled from 'styled-components';

import { useAppSelector } from '../../../store';
import craftJsParser from '../../../components/utils/craftJsParser';

import { StateGridItems } from '../StateGridItems/StateGridItems';
import { DataElementContext } from '../../common/DataElementContext';
import { getStateValue } from '../../utils/getStateValue';
import triggerStateLoaderIfNeeded from '../../utils/hooks/triggerStateLoaderIfNeeded';
import { PageDataContext, getProjectDataFromContext } from '../../../components/utils/PageDataProvider';

const defaultProps = {
  className: '',
  styleText: `
  width: 100%;
  height: auto;
  `,
  properties: {
    items: 6,
    dsType: '',
  },
};

const StateGridDiv = styled.div`
  overflow-y: hidden;
  overflow-x: auto;
  ${(props) => props.$styleText}
`;

export const StateGrid = (componentProps) => {
  let props = componentProps;

  const config = useAppSelector((state) => state.templatesConfig);
  const pageDataContext = React.useContext(PageDataContext);

  let hasError = false;
  let content = null;

  try {
    const dsType = props.properties?.dsType ?? '';
    const det = dsType ? config.dataElementTypes[dsType] : null;

    let stateKey = '';

    if (det && det.internal && det.internal.length) {
      const from = det.internal.find((el) => el.id === 'from');
      const path = det.internal.find((el) => el.id === 'path');
      if (from && from.value === 'state') {
        if (path && path.value) stateKey = path.value;
      }
    }

    if (!stateKey) return null;
    triggerStateLoaderIfNeeded(stateKey);

    const stateItems = useAppSelector((state) => getStateValue(state, stateKey));
    if (!stateItems) return null;

    const data = getProjectDataFromContext(pageDataContext);

    const dsWrapperData = data[props.linkedNodes['ds-lister-items']];

    const itemContent = craftJsParser({
      craftState: data,
      rootNodeId: dsWrapperData.nodes[0],
      pageId: props.refType === 'layout' ? null : props.refId,
      pageLayoutId: props.refType === 'layout' ? props.refId : null,
      pageType: props.refType,
    });

    const rendered =
      stateItems?.map((item, i) => {
        return (
          <DataElementContext.Provider key={i} value={item}>
            {itemContent}
          </DataElementContext.Provider>
        );
      }) || [];

    content = <StateGridItems {...dsWrapperData.props}>{rendered}</StateGridItems>;
  } catch (err) {
    console.error(err);
    hasError = true;
  }

  if (hasError) return null;

  return (
    <StateGridDiv className={props.className ?? ''} $styleText={props.styleText} style={props.style}>
      {content}
    </StateGridDiv>
  );
};
